import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoaderModule } from '../loader/loader.module';



@NgModule({
  declarations: [ModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    LoaderModule,
    ReactiveFormsModule
  ],
  exports:[ModalComponent]
})
export class ModalModule { }
